// extracted by mini-css-extract-plugin
module.exports = {"Verger":"Verger_1OuN","Verger__block":"Verger__block_1JyC","Verger__eco":"Verger__eco_9xFO","Verger__visual":"Verger__visual_3_S0"};